import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import { BookingProvider } from "@/contexts/BookingContext";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminChatSession from "@/pages/AdminChatSession";

import FloatingContact from "@/components/landing/FloatingContact";
import ChatWidget from "@/components/ChatWidget";

function SiteShell({ children }) {
  // Shared providers + global widgets for public-facing pages (NOT /admin).
  return (
    <BookingProvider>
      {children}
      <ChatWidget />
      <FloatingContact />
    </BookingProvider>
  );
}

export default function App() {
  // Strip prerender / static data-rh head tags once at runtime so react-helmet-async
  // becomes the single source of truth in-browser (React 19 + helmet-async v3 no
  // longer replaces them automatically). Crawlers and initial curl still see the
  // static per-route tags because JS hasn't run yet — perfect for SEO.
  useEffect(() => {
    document.head.querySelectorAll('[data-rh="true"]').forEach((el) => el.remove());
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            {/* Admin routes — no chat widget, no booking dialog */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/chat-sessions/:sessionId" element={<AdminChatSession />} />
            <Route path="/admin" element={<AdminDashboard />} />

            {/* Public site routes */}
            <Route
              path="/"
              element={
                <SiteShell>
                  <Home />
                </SiteShell>
              }
            />
            <Route
              path="/payment-success"
              element={
                <SiteShell>
                  <PaymentSuccess />
                </SiteShell>
              }
            />
            <Route
              path="/privacy"
              element={
                <SiteShell>
                  <Privacy />
                </SiteShell>
              }
            />
            <Route
              path="/:slug"
              element={
                <SiteShell>
                  <ServicePage />
                </SiteShell>
              }
            />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}
